<template>
  <div id="internal-wallet-deposit">
    <vs-alert color="danger" icon-pack="feather" icon="icon-alert-triangle" class="mb-4" active="true" v-if="wallet && wallet.internal.name == 'toman' && listCards.length < 1">
      {{$t('You do not have a verified bank account.')}}
    </vs-alert>

    <transition name="zoom-fade">
      <div class="grid grid-cols-12 gap-6" v-if="!wallet">
        <div class="lg:col-span-7 col-span-12">
          <vue-skeleton-loader  animation="fade" type="rect" rounded width="100%" height="200px" class="mb-4"/>
          <vue-skeleton-loader  animation="fade" type="rect" rounded width="100%" height="350px" class="mb-4"/>
        </div>
        <div class="lg:col-span-5 col-span-12" v-if="!isSmallerScreen">
          <vue-skeleton-loader  animation="fade" type="rect" rounded width="100%" height="550px" class="mb-4"/>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-6" v-if="wallet">

        <div class="lg:col-span-7 col-span-12">
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12">
              <statistics-card-line
                icon="CreditCardIcon"
                icon-right
                :statistic="wallet.balance.toLocaleString('en-US') +' '+ $t(wallet.internal.name)"
                :statisticTitle="$t('Balance')+' ('+ $t(wallet.internal.symbol) +') '"
                type="area"
                :hideChart="chart.series[0].data.length <=2 ? true : false"
                to-locale-str
                color="success"
                :chartData="chart.series" />
            </div>

            <vx-card class="col-span-12" collapseAction :title="$t('Deposit to wallet')">
              <div slot="no-body" class="tabs-container lg:px-6 pt-6 px-1">
                <vs-tabs color="primary" class="tab-action-btn-fill-conatiner">
                  <vs-tab :label="isSmallerScreen ? $t('payment gateway') : $t('Deposit from payment gateway')" icon-pack="feather" icon="icon-credit-card">
                    <PaymentGateway :wallet="wallet" :listGatway="listGatway"/>
                  </vs-tab>
                  <vs-tab :label="isSmallerScreen ? $t('receipt') : $t('Deposit via receipt')" icon-pack="feather" icon="icon-file-plus">
                    <Receipt :wallet="wallet" :listCards="listCards" :Receipt="receipt"/>
                  </vs-tab>
                </vs-tabs>

              </div>
            </vx-card>
          </div>
        </div>

        <vx-card class="lg:col-span-5 col-span-12" collapseAction :title="$t('Tips for depositing')">

          <div slot="no-body" class="tabs-container lg:px-6 pt-6 px-1">
            <p class="mb-3">
              جهت واریز وجه، حتما باید از کارت‌های بانکی به نام خودتان که در بخش کاربری ثبت و تایید شده است، استفاده نمایید.
            </p>
            <p class="mb-3">
              در تعیین مبلغ واریز به این موضوع دقت نمایید که حداقل مبلغ خرید و فروش در فراچنج 11 دلار است است.
            </p>

          </div>
        </vx-card>
    </div>

    </transition>
    <History :coin="true" class="mt-base" ref="History"/>
  </div>

</template>
<i18n locale="fa">
{
  "Deposit to wallet":"واریز به کیف پول"
  ,"Tips for depositing":"نکات جهت واریز"
  ,"Deposit from payment gateway":"واریز از طریق درگاه پرداخت"
  ,"Deposit via receipt":"واریز از طریق فیش"
  ,"payment gateway":"درگاه بانکی"
  ,"receipt":"فیش"
  ,"You do not have a verified bank account.":"حساب بانکی تایید شده ای ندارید."

}
</i18n>
<script>
  import axios from '../../../../axios'
  import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
  import PaymentGateway from "./PaymentGateway";
  import Receipt from "./Receipt";
  import History from "../../../tools/history/internal/Internal";
  import VueSkeletonLoader from 'skeleton-loader-vue';

  export default {
    data () {
      return {
        wallet: null,
        listGatway: null,
        listCards: null,
        receipt: null,
        selected:[],
        //filter Tabel
        filterModelOptions: [
          {text: 'deposit & withdraw', value:''},
          {text: 'deposit', value:'deposit'},
          {text: 'withdraw', value:'withdraw'}
        ],
        filterModel:'',
        historyTransaction: [],
        chart: {
          series: [{
              name: this.$t('Balance'),
              data: []
          }]
        },
      }
    },
    computed: {
    },
    components: {
      StatisticsCardLine,
      PaymentGateway,Receipt,
      History,VueSkeletonLoader
    },
    watch:{

    },
    methods:{
      refreshData(){
        this.getWallet();
        this.$refs.History.getList();
      },
      getWallet(){
        const self = this
        axios.post('/wallets/internal').then(function (response) {
          self.wallet = response.data.wallet
          self.listGatway = response.data.list_gatway
          self.listCards = response.data.list_cards
          self.receipt = response.data.receipt
          self.chart.series[0].data = response.data.chart
        }).catch(function (error) { console.log(error); })
      },
      addLocalName () {
        const historyTransaction = this.historyTransaction
        const i18n = this.$i18n
        historyTransaction.map(function (value, key) {
          historyTransaction[key].Model_local = i18n.t(historyTransaction[key].Model)
        })
        this.historyTransaction = historyTransaction
      }
    },
    mounted () {
      this.addLocalName();
    },
    created () {
      this.getWallet();
    }
  }
</script>

<style lang="scss">
  #internal-wallet-deposit {


    .ul-tabs .vs-tabs--li button {
      font-size: 16px;
    }
    .font-large-6 {
      font-size: 115px;
    }

  }
</style>
